import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FormValidation from "../../Common/FormValidation";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";

const Solve = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [ticket, setTicket] = useState({});
  const [error, setError] = useState({});
  const [inputs, setInputs] = useState({
    solution_date: new Date().toISOString().slice(0, 10),
    solution_time: new Date().toTimeString().slice(0, 8),
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  const fetchData = () => {
    Http.get("/crm/" + id).then((res) => {
      setTicket(res.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const formSubmit = () => {
    Http.post("/crm-solve/" + id, inputs)
      .then((res) => {
        navigate("/crm", {
          state: { message: res.data.message, type: "success" },
        });
      })
      .catch(function (e) {
        setError(e.response.data.errors ? e.response.data.errors : {});
      });
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Ticket Solve</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Ticket No: {ticket.ticket_no} &nbsp; | &nbsp; {ticket.ticket_for} &nbsp; | &nbsp; {ticket.complain_type}
            </h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>

            <div className="row">
              <div className="col-lg">
                <label>
                  Date <i className="fa fa-star required"></i>
                </label>
                <input type="date" className="form-control" name="solution_date" value={inputs.solution_date || ""} onChange={handleChange} />
              </div>
              <div className="col-lg">
                <label>
                  Time <i className="fa fa-star required"></i>
                </label>
                <input type="time" step="1" className="form-control" name="solution_time" value={inputs.solution_time || ""} onChange={handleChange} />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-lg">
                <label>Remarks:</label>
                <textarea className="form-control" name="solution_message" value={inputs.solution_message || ""} onChange={handleChange}></textarea>
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-9"></div>
              <div className="col-3">
                <button className="btn btn-primary btn-block mg-b-10" onClick={formSubmit}>
                  <i className="fa fa-send mg-r-10"></i> Save
                </button>
              </div>
            </div>
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Solve;
